import {
  useArchiveTeamMember,
  useIssueTempPassword,
  useRestoreTeamMember,
} from './use-approacher-mutations';
import { useResetStreak } from './use-reset-streak';
import type { DetailMode } from '../components/approacher-detail-view';

export type Mode = DetailMode | 'edit';

type ResetState = { pwd: string; setPwd: (v: string) => void };

export function useResetActions(
  id: string,
  reset: ResetState,
  setMode: (m: Mode) => void
) {
  const issue = useIssueTempPassword();
  return {
    onConfirmReset: (): void => {
      issue.mutate(id, {
        onSuccess: (r) => {
          reset.setPwd(r.temp_password);
          setMode('reset-reveal');
        },
      });
    },
    resetPending: issue.isPending,
  };
}

export function useStreakResetActions(id: string, setMode: (m: Mode) => void) {
  const reset = useResetStreak();
  return {
    onConfirmStreakReset: (): void => {
      reset.mutate(id, { onSuccess: () => setMode('view') });
    },
    streakResetPending: reset.isPending,
  };
}

export function useActions(id: string, onClose: () => void) {
  const archive = useArchiveTeamMember();
  const restore = useRestoreTeamMember();
  return {
    onConfirmArchive: () => archive.mutate(id, { onSuccess: onClose }),
    onConfirmRestore: () => restore.mutate(id, { onSuccess: onClose }),
    pending: archive.isPending || restore.isPending,
  };
}

export function modeHandlers(setMode: (m: Mode) => void) {
  return {
    onEdit: () => setMode('edit'),
    onArchive: () => setMode('archive'),
    onRestore: () => setMode('restore'),
    onReset: () => setMode('reset-confirm'),
    onStreakReset: () => setMode('streak-reset-confirm'),
    onUploadPhoto: () => setMode('photo-upload'),
    onVacation: () => setMode('vacation'),
    onStatusEdit: () => setMode('status-edit'),
    onCancel: () => setMode('view'),
  };
}
